<template>
	<div>
		<AudienceNotesPanel :content-id="id" :view="view" />
	</div>
</template>

<script>
import AudienceNotesPanel from '@/components/lessonPlan/components/slides/notes/AudienceNotesPanel.vue';

export default {
  name: "AudienceNotes",
  props: ["id", "view"],
  components: { AudienceNotesPanel }
}
</script>
